module.exports = __webpack_public_path__ + "img/case.10f66457.png";